import { TriageActionConfigSnapshot } from 'src/graphql/entities/conversation-triage/conversation-triage.types';
import { parseJsonSafely } from 'src/utils/objects';

export function parseTriageActionConfig(
  raw: string | null | undefined,
): TriageActionConfigSnapshot {
  return parseJsonSafely<TriageActionConfigSnapshot>(raw ?? '') ?? {};
}
